import { memo, useCallback } from 'react';

import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ComponentStack,
  Dialog,
  Heading,
  Modal,
  ModalOverlay,
  ModalOverlayProps,
  useComponentStack,
} from '@/components/core';
import { Flex, Text } from '@/components/core';

import { AddIcon, CloseIcon } from '../icons';
import { AddOrEditRole } from './AddOrEditRole';
import { RolesTable } from './RolesTable';

type ComponenWrapperProps = {
  close?: () => void;
};

const ComponentWrapper = ({ close }: ComponenWrapperProps) => {
  const { push, pop } = useComponentStack();

  const onAddRole = useCallback(() => {
    push(<AddOrEditRole close={pop} />);
  }, [pop, push]);

  return (
    <Flex variant="plain" col>
      <CardHeader>
        <Flex col className="grow">
          <Heading>Manage roles</Heading>
          <Text variant="tertiary">Manage your team roles here.</Text>
        </Flex>

        <CloseIcon onClick={close} className="cursor-pointer text-gray-400" />
      </CardHeader>

      <CardBody col className="gap-md grow items-start overflow-auto">
        <RolesTable />
      </CardBody>

      <CardFooter separator>
        <Button variant="secondary" onPress={onAddRole}>
          <AddIcon />
          <Text>New role</Text>
        </Button>
      </CardFooter>
    </Flex>
  );
};

type ListRolesModalProps = ModalOverlayProps;

const IListRolesModal = ({ ...rest }: ListRolesModalProps) => {
  return (
    <ModalOverlay {...rest}>
      <Modal>
        <Dialog>
          {({ close }) => (
            <Card className="max-h-120 w-120 border-none">
              <ComponentStack>
                <ComponentWrapper close={close} />
              </ComponentStack>
            </Card>
          )}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};

export const ListRolesModal = memo(IListRolesModal);
